import { Insurance } from '../../../member-profile/components/Insurance';

const InsurancePage = () => {
    return <Insurance />;
};

export default InsurancePage;
